export default {
    namespaced: true,
    state: {
        collections: [],
        supplierCollections: []
    },
    getters: {
        collections(state) {
            return state.collections
        },
        nameCollection: state => id => {
            const collection = state.collections.find(el => {
                if (el.CollectionID === id * 1) {
                    return el
                }
            })
            return collection ? collection.Name : ''
        },
        getSupplierCollectionsByBrand: state => ids => {
            if (!ids.length) return state.supplierCollections
            const idsArr = ids.map(id => parseInt(id))
            return state.supplierCollections.filter(
                item => idsArr.indexOf(parseInt(item.BrandID)) !== -1
            )
        },
        //values for supplier products page filter, default all
        supplierCollectionsValuesArr(state) {
            return state.supplierCollections.map(
                collection => collection.CollectionID
            )
        }
    },
    mutations: {
        SET_COLLECTIONS(state, collections) {
            state.collections = collections
        },
        SET_SUPPLIER_COLLECTIONS(state, collections) {
            state.supplierCollections = collections
        }
    },
    actions: {
        async getCollections({ commit }, data) {
            const collections = await this.$axios
                .get('/public/dict/collections', {
                    params: data
                })
                .then(res => {
                    return res.data
                })

            if (data && data.existing) {
                commit('SET_SUPPLIER_COLLECTIONS', collections)
            } else {
                commit('SET_COLLECTIONS', collections)
            }
        }
    }
}
